var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "redAngle",
      class: { "clickable show-locator-modal": _vm.forceManualStoreSelection },
      on: {
        click: function($event) {
          _vm.forceManualStoreSelection && _vm.openLocatorModal()
        }
      }
    },
    [
      _c("div", { staticClass: "angleCorrect" }, [
        _c("div", { staticClass: "locationContainer" }, [
          _c("div", {
            staticClass: "locPin clickable",
            on: { click: _vm.openLocatorModal }
          }),
          _vm._v(" "),
          _vm.selectedStore
            ? _c("div", { staticClass: "containerText" }, [
                _c("p", { class: _vm.longStoreNameClass }, [
                  _c("strong", [_vm._v(_vm._s(_vm.storeName))])
                ]),
                _vm._v(" "),
                _c("p", { class: _vm.longAddressClass }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.addressLine) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.selectedStore.phone
                  ? _c(
                      "a",
                      {
                        attrs: { href: "tel:" + _vm.cleanPhone },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.selectedStore.phone) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "appointment-in-nav",
                    attrs: { "data-open": "scheduleModal" }
                  },
                  [_vm._v("Request Appointment")]
                )
              ])
            : _vm.forceManualStoreSelection
            ? _c("div", { staticClass: "containerText" }, [_vm._m(0)])
            : _c("div", { staticClass: "containerText" }, [
                _c("p", [_vm._v("Loading...")])
              ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button myStoreBt",
            attrs: { type: "button", "data-toggle": _vm.offCanvas }
          },
          [
            _c("img", {
              staticClass: "storeBt",
              attrs: {
                src:
                  "/wp-content/themes/ferg-framework/assets/images/ico_store.svg",
                alt: "Store Details"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("My Store")])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Choose Location")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }